import React, { useState, useEffect } from 'react'
import MultiSelect from  'react-multiple-select-dropdown-lite'
import  'react-multiple-select-dropdown-lite/dist/index.css'
import Field from './Field'
import styles from './Form.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { addNewSpecies, updateSpecies } from '../../../actions/actions'




const Form = ( { currentId, setCurrentId  }) => {

  const dispatch = useDispatch()
    
    const [options,setOptions]= useState({
        commonName: '',
        scientificName: '',
        imageUrl: '',
        imageName: '',
        group: '',
        location: '',
        status: '',
        size: '',
        mainColors: [],
        headColor: [],
        upperColor: [],
        bellyColor: [],
        habitat: [],
        billShape: '',
        tailShape: '',
    })

  
  const [image, setImage] = useState([])
  const post = useSelector((state) => currentId ? state.posts.find((p) => p._id === currentId) : null)

  useEffect(() => {
    if(post) {
      setOptions(post)
    }
  }, [post])

  const imageDetails = () => {
    const data = new FormData()
    data.append("file", image)
    data.append("upload_preset","birdid-app")
    data.append("cloud_name", "wabis")
    fetch("https://api.cloudinary.com/v1_1/wabis/image/upload", {
      method: "post",
      body: data
    })
    .then(res => res.json())
    .then(data => {
      console.log(data)
      setOptions({...options, imageUrl: data.url, imageName: data.name })
    })
    .catch(error => {
      console.log(error)
    })
  }

console.log(image.name)
console.log(options)

useEffect(() => {
  imageDetails()
  // eslint-disable-next-line
},[image])

  const sizeOptions = [
    { label: "Sparrow-Thrush Size", value: "Sparrow-Thrush Size" },
    { label: "Thrush-Size", value: "Thrush-Size" },
    { label: "Sparrow-Size", value: "Sparrow-Size" },
    { label: "Thrush-Crow Size", value: "Thrush-Crow Size" },
    { label: "Crow-Size", value: "Crow-Size" },
    { label: "Crow-Turkey Size", value: "Crow-Turkey Size" },
    { label: "Turkey-Size", value: "Turkey-Size" }
  ]


  const  colorOptions  = [
    { label: 'black', value: 'black'},
    { label: 'brown', value: 'brown'},
    { label: 'red', value: 'red'},
    { label: 'gray', value: 'gray'},
    { label: 'blue', value: 'blue'},
    { label: 'cyan', value: 'cyan'},
    { label: 'purple', value: 'purple'},
    { label: 'yellow', value: 'yellow'},
    { label: 'green', value: 'green'},
    { label: 'white', value: 'white'},
    
  ]

  const  billOptions  = [
    { label: "cornical", value: "cornical" },
    { label: "forked", value: "forked" },
    { label: "Hooked", value: "Hooked" },
    { label: "Long & Spear-shaped", value: "Long & Spear-shaped" },
    { label: "Short, thin, pointy", value: "Short, thin, pointy" },
    { label: "Short, tiny, pointy", value: "Short, tiny, pointy" },
    { label: "Thick, large decurved", value: "Thick, large decurved" },
    { label: "Thin, long and decurved", value: "Thin, long and decurved" },
  ]

  const  tailOptions  = [
    {label:"Cleft", value: "Cleft" },
    {label: "Double-Rounded", value: "Double-Rounded" },
    {label: "Forked", value: "Forked" },
    {label: "Graduated", value: "Graduated" },
    {label: "Narrow", value: "Narrow" },
    {label: "Ribbon-like", value: "Ribbon-like" },
    {label: "Ribbon-like; Rounded", value: "Ribbon-like; Rounded" },
    {label: "Rounded", value: "Rounded" },
    {label: "Short", value: "Short" },
    {label: "Wedged", value: "Wedged" },
  ]

  const  groupOptions  = [
    { label: "Bulbuls & Greenbuls", value: "Bulbuls & Greenbuls" },
    { label: "Pigeons & Doves", value: "Pigeons & Doves" },
    { label: "Warblers", value: "Warblers" },
    { label: "Others", value: "Others" },
    { label: "Hornbills", value: "Hornbills" },
    { label: "Weavers & Sparrows", value: "Weavers & Sparrows" },
    { label: "Waterbird", value: "Waterbird" },
    { label: "Finches", value: "Finches, value" },
    { label: "Thrushes & Chats", value: "Thrushes & Chats" },
    { label: "Swifts & Swallows", value: "Swifts & Swallows" },
    { label: "Raptor", value: "Raptor" },
    { label: "Groundbird", value: "Groundbird" },
    { label: "Sunbirds", value: "Sunbirds" },
    { label: "Parrots", value: "Parrots" },
    { label: "Cisticolas", value: "Cisticolas" },
    { label: "Bee-Eaters", value: "Bee-Eaters" },
    { label: "Woodpeckers", value: "Woodpeckers" },

  ]

  const habitatOptions = [
    { label: "Woodland",value: "Woodland" },
    { label: "Farmland",value: "Farmland" },
    { label: "Grassland",value: "Grassland" },
    { label: "Forest Edge",value: "Forest Edge" },
    { label: "Wetland",value: "Wetland" },
    { label: "Gallery forest",value: "Gallery forest" },
    { label: "Generalist",value: "Generalist" },
    { label: "Forest interior",value: "Forest interior" },
    { label: "Rocky-Outcrop",value: "Rocky-Outcrop" },
  ]


  const handleChange =(e) => {
    setOptions({...options, [e.target.name]: e.target.value})
  }

  const  handleMainColors  =  val  => {
   
    setOptions({...options, mainColors: val.split(",")})
    
  }
  const  handleSizeOptions  =  val  => {
    
    setOptions({...options, size: val})
    
  }

  const  handleHeadColor  =  val  => {
   
    setOptions({...options, headColor: val.split(",")})
    
  }

  const  handleUpperColor  =  val  => {
    
    setOptions({...options, upperColor: val.split(",")})
    
  }
  const  handleBellyColor  =  val  => {
   
    setOptions({...options, bellyColor: val.split(",")})
    
  }
  const  handleHabitatOption  =  val  => {
   
    setOptions({...options, habitat: val.split(",")})
    
  }
  const  handleBillShape  =  val  => {
    
    setOptions({...options, billShape: val})
    
  }
  const  handleTailShape  =  val  => {
  
    setOptions({...options, tailShape: val})
    
  }
  const  handleGroup  =  val  => {
   
    setOptions({...options, group: val})
    
  }

  const handleSubmit = (e)=> {
    e.preventDefault()

    if(currentId) {
      dispatch(updateSpecies(currentId, options))
    } else {
      dispatch(addNewSpecies(options))
    }
    clear()
    // window.location.reload(true);
  }


const clear =()=> {
  setCurrentId(null)
  setOptions({ commonName: '', scientificName: '', imageUrl: '', imageName: '', group: '', location: '', status: '', size: '', mainColors: [], headColor: [], upperColor: [], bellyColor: [], habitat: [], billShape: '', tailShape: '', })
}

  return(
    <div className={styles.form}>
      <h3>{ currentId ? 'Edit' : 'Add new '} Species </h3>
    <form onSubmit={handleSubmit} >

        <div className={styles.fileUpload}>
        <input type="file" id="upload"  hidden onChange={(e)=> setImage(e.target.files[0])} />
          <div className={styles.upload}>
          <p>{image.name? image.name : "Upload picture"}</p>
          <label htmlFor="upload">Choose file <i className="far fa-file-image"></i></label>
          </div>
        </div>
        <Field tye="text" name="commonName" handleChange={handleChange} defaultValue={options.commonName} placeholder="Common Name" />
        <Field tye="text" name="scientificName" handleChange={handleChange} defaultValue={options.scientificName} placeholder="Scientific Name" />
        <MultiSelect singleSelect="true" onChange={handleGroup} options={groupOptions} name="group" defaultValue={options.group} style={{width: "90%", margin: "20px"}} placeholder="Group" />
        <MultiSelect singleSelect="true" onChange={handleSizeOptions} options={sizeOptions} name="mainColors" defaultValue={options.size} style={{width: "90%", margin: "20px"}} placeholder="Size"/>
        <MultiSelect onChange={handleMainColors} options={colorOptions} name="mainColors" defaultValue={options.mainColors} style={{width: "90%", margin: "20px"}} placeholder="Select main colors"/>
        <MultiSelect onChange={handleHeadColor} options={colorOptions} name="headColor" defaultValue={options.headColor} style={{width: "90%", margin: "20px"}} placeholder="Select head color" />
        <MultiSelect onChange={handleUpperColor} options={colorOptions} name="upperColor" defaultValue={options.upperColor} style={{width: "90%", margin: "20px"}} placeholder="Select upper color" />
        <MultiSelect onChange={handleBellyColor} options={colorOptions} name="bellyColor" defaultValue={options.bellyColor} style={{width: "90%", margin: "20px"}} placeholder="Select belly color" />
        <MultiSelect onChange={handleHabitatOption} options={habitatOptions} name="habitat" defaultValue={options.habitat} style={{width: "90%", margin: "20px"}} placeholder="Select habitats" />
        <MultiSelect singleSelect="true" onChange={handleBillShape} options={billOptions} name="billShape" defaultValue={options.billShape} style={{width: "90%", margin: "20px"}} placeholder="Bill Shape" />
        <MultiSelect singleSelect="true" onChange={handleTailShape} options={tailOptions} name="tailShape" defaultValue={options.tailShape} style={{width: "90%", margin: "20px"}} placeholder="Tail Shape" />
        <div className={styles.navButtons}>
            <button onClick={handleSubmit} className={styles.submitBtn} type="submit">Submit</button>
            <button onClick={clear} className={styles.clear} >Clear</button>
        </div>
    </form>
    </div>
)}
export  default Form